import React from "react";
import { Button, Col, Modal, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;
const BitelModalNoti = ({
  message,
  title,
  visible,
  handleOk,
  handleCancel,
  btnSuccess,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      className="page-modal modal-notification"
      centered
      maskClosable={false}
      visible={visible}
      onCancel={handleCancel}
      footer={[
        <Row justify="center" key={1}>
          <Col md={15}>
            <Button className="page-modal-button" onClick={handleOk}>
              {btnSuccess || t("modal.ok")}
            </Button>
          </Col>
        </Row>,
      ]}
    >
      <Row justify="center">
        <Col md={24}>
          <Title
            level={3}
            className="page-modal-title page-modal-title-success"
          >
            {title}
          </Title>
          <div
            className="page-modal-content ant-typography"
            dangerouslySetInnerHTML={{ __html: message }}
          ></div>
        </Col>
      </Row>
    </Modal>
  );
};

export default BitelModalNoti;
